// What screen B's action buttons send to POST /api/foia/requests/:id/actions,
// keyed by step key. The server (server/utils/foia/actionCodes.js) is the
// source of truth — it validates every code against foia_action_type — this
// is just which code each button maps to.
export const DELETION_REQUEST_ACTION_CODE = "USER_DELETION_REQUEST_LOGGED";
export const CLOSE_REQUEST_ACTION_CODE = "USER_REQUEST_CLOSED";

export const STEP_KEY_TO_ACTION_CODE = {
  deletion_requested: DELETION_REQUEST_ACTION_CODE,
  intake_email: "USER_RETENTION_INTAKE_EMAIL_SENT_CONFIRMED",
  cannot_retain_email: "USER_CANNOT_RETAIN_EMAIL_SENT_CONFIRMED",
  engineering_retain: "USER_RETENTION_CONFIRMED",
  data_received: "USER_RETENTION_DATA_RECEIVED",
  cor_requested: "USER_COR_SHARE_REQUEST_RECEIVED",
  uploaded: "USER_SHAREPOINT_UPLOAD_CONFIRMED",
  completion_email: "USER_RETENTION_COMPLETION_EMAIL_SENT_CONFIRMED",
  engineering_delete: "USER_DELETION_CONFIRMED",
  deletion_email: "USER_DELETION_EMAIL_SENT_CONFIRMED",
};

// Generating a draft (EmailDraftCard mounting) records its own internal
// AGENT_..._PREPARED code, separate from the USER_..._SENT_CONFIRMED code
// above that "I sent this email" records.
export const STEP_KEY_TO_PREPARED_ACTION_CODE = {
  intake_email: "AGENT_RETENTION_INTAKE_EMAIL_PREPARED",
  cannot_retain_email: "AGENT_CANNOT_RETAIN_EMAIL_PREPARED",
  completion_email: "AGENT_RETENTION_COMPLETION_EMAIL_PREPARED",
  deletion_email: "AGENT_DELETION_EMAIL_PREPARED",
};
